import axios from "@/axios.js";

const STUTUS_LOADING = "loading";
const STATUS_ERROR = "error";

const defaultFilters = {
    search: "",
    page: 1,
    perPage: 10,
};

const paths = {
    get: "/orders",
    create: "/orders/checkout",

    getById(id) {
        return `/orders/${id}`;
    },
    getPaymentByOrderId(id) {
        return `/orders/${id}/payment`;
    },
    cancelByOrderId(id) {
        return `/orders/${id}/cancel`;
    },
    generateQRByOrderId(id) {
        return `/orders/${id}/generate-qr`;
    },
    updateContactByOrderId(id) {
        return `/orders/${id}/contact`;
    },
};

export default {
    namespaced: true,
    state: {
        orders: [],

        filters: defaultFilters,

        meta: {
            total: 0,
            perPage: 2,
            page: 1,
        },

        statuses: [
            { value: "", text: "All" },
            { value: "pending", text: "Pending" },
            { value: "expired", text: "Expired" },
            { value: "cancelled", text: "Cancelled" },
        ],

        status: null,
    },
    mutations: {
        CLEAR_ORDERS(state) {
            state.orders = [];
        },
        SET_ORDERS(state, orders) {
            state.orders = state.orders.concat(orders);
        },

        SET_FILTERS(state, filters) {
            state.filters = {
                ...state.filters,
                ...filters,
            };
        },

        SET_META(state, meta) {
            state.meta = {
                ...state.meta,
                ...meta,
            };
        },

        SET_STATUS(state, status) {
            state.status = status;
        },
    },
    actions: {
        async fetchOrders({ commit }, filters = defaultFilters) {
            if (this.state.status == STUTUS_LOADING) {
                return;
            }

            commit("SET_STATUS", STUTUS_LOADING);

            const payload = {
                ...this.state.meta,
                ...filters,
            };

            if (payload.page == 1) {
                commit("CLEAR_ORDERS");
            }

            commit("SET_FILTERS", filters);

            // delay for 1 second
            await new Promise((resolve) => setTimeout(resolve, 1000));

            try {
                const { data: response } = await axios.get(paths.get, {
                    params: payload,
                });

                commit("SET_ORDERS", response.data);

                // set options
                commit("SET_META", response.meta);

                // return orders;
            } catch (error) {
                commit("SET_STATUS", STATUS_ERROR);
                throw error;
            } finally {
                commit("SET_STATUS", null);
            }
        },

        getOrder({ commit }, id) {
            const orders = require("./mock").default;
            const order = orders.data.find((order) => order.id == id);

            return {
                data: order,
            };
        },

        searchOrder({ dispatch }, search) {
            return dispatch("fetchOrders", {
                ...this.state.filters,
                page: 1,
                search,
            });
        },

        setFilters({ dispatch, commit }, filters) {
            commit("SET_FILTERS", filters);

            return dispatch("fetchOrders", filters);
        },

        async purchase({}, payload) {
            try {
                const { data: response } = await axios.post(
                    paths.create,
                    payload
                );

                return response.data;
            } catch (error) {
                console.log("error", error);
                throw error;
            }
        },

        async fetchOrderById({ commit }, id) {
            try {
                const { data: response } = await axios.get(paths.getById(id));
                return response.data;
            } catch (error) {
                // TODO: handle error
                throw error;
            }
        },
        async fetchPaymentByOrderId({ commit }, id) {
            try {
                const { data: response } = await axios.get(
                    paths.getPaymentByOrderId(id)
                );
                return response.data;
            } catch (error) {
                // TODO: handle error
                throw error;
            }
        },

        async cancelOrderById({ commit }, id) {
            try {
                const { data: response } = await axios.post(
                    paths.cancelByOrderId(id)
                );
                return response.data;
            } catch (error) {
                throw error;
            }
        },
        async generateQRById({ commit }, id) {
            try {
                const { data: response } = await axios.post(
                    paths.generateQRByOrderId(id)
                );
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async updateContact({ commit }, { id, payload }) {
            try {
                const { data: response } = await axios.put(
                    paths.updateContactByOrderId(id),
                    payload
                );
                return response.data;
            } catch (error) {
                throw error;
            }
        },
    },
    getters: {
        list: (state) => state.orders,
        filters: (state) => state.filters,
        meta: (state) => state.meta,
        status: (state) => state.status,
    },
};
